import React from "react";

class BootCamp extends React.Component {
  render() {
    const { state, setState, isEdit } = this.props;

    return (
      <>
        <div className="row">
          <div className="col-md-4">
            <label className="pb-1">Event Start Date</label>
            <input
              onChange={(event) =>
                setState({ eventStartDate: event.target.value })
              }
              value={state.eventStartDate || ""}
              type="date"
              name="eventStartDate"
              className="form-control"
              required
            />
          </div>

          <div className="col-md-4">
            <label className="pb-1">Event End Date</label>
            <input
              onChange={(event) =>
                setState({ eventEndDate: event.target.value })
              }
              value={state.eventEndDate || ""}
              type="date"
              name="eventEndDate"
              className="form-control"
              required
            />
          </div>

          <div className="col-md-4">
            <label className="pb-1">Select Certificate</label>
            <select
              onChange={(event) =>
                setState({ certificateType: event.target.value })
              }
              value={state.certificateType || ""}
              name="certificateType"
              className="form-select form-control"
              required
              disabled={isEdit}
            >
              <option value="participation">Participation</option>
              <option value="accomplishment">Accomplishment</option>
            </select>
          </div>
        </div>
      </>
    );
  }
}

export default BootCamp;
